<template>
  <div class="p-3">
    <div class="row">
      <div class="col-12 col-md-6 col-lg-4 p-1">
        <label class="control-label visible-ie8 visible-ie9" for="email">Email</label>
        <div class="input-group">
          <input
                  :class="{'form-control': true, 'is-invalid': errors.has('email')}"
                  v-validate="'required|email'"
                  data-vv-delay="500"
                  data-vv-as="Email"
                  data-vv-name="email"
                  type="text"
                  placeholder="Email"
                  name="email"
                  id="email"
                  v-model="user.email"/>
          <div class="input-group-append" v-show="emailLoading">
            <span class="input-group-text">
              <font-awesome-icon icon="cog" spin></font-awesome-icon>
            </span>
          </div>
        </div>
        <div class="invalid-tooltip d-block" v-if="errors.has('email')">{{ errors.first('email') }}</div>
      </div>
      <div class="col-12 col-md-6 col-lg-4 p-1">
        <label class="control-label visible-ie8 visible-ie9" for="name_first">First Name</label>
        <input
                :class="{'form-control': true, 'is-invalid': errors.has('name_first')}"
                v-validate="'required'"
                data-vv-delay="500"
                data-vv-as="First Name"
                data-vv-name="name_first"
                type="text"
                placeholder="First Name"
                name="name_first"
                id="name_first"
                v-model="user.name_first"/>
        <div class="invalid-tooltip d-block" v-if="errors.has('name_first')">{{ errors.first('name_first') }}</div>
      </div>
      <div class="col-12 col-md-6 col-lg-4 p-1">
        <label class="control-label visible-ie8 visible-ie9" for="name_last">Last Name</label>
        <input
                :class="{'form-control': true, 'is-invalid': errors.has('name_last')}"
                v-validate="'required'"
                data-vv-delay="500"
                data-vv-as="Last Name"
                data-vv-name="name_last"
                type="text"
                placeholder="Last Name"
                name="name_last"
                id="name_last"
                v-model="user.name_last"/>
        <div class="invalid-tooltip d-block" v-if="errors.has('name_last')">{{ errors.first('name_last') }}</div>
      </div>
      <div class="col-12 col-md-6 col-lg-4 p-1">
        <label class="control-label visible-ie8 visible-ie9" for="address_street">Street Name</label>
        <input :class="{'form-control': true, 'is-invalid': errors.has('address_street')}"
               v-validate="'required'"
               data-vv-delay="500"
               data-vv-as="Street Name"
               data-vv-name="address_street"
               type="text"
               placeholder="Street Name"
               name="address_street"
               id="address_street"
               v-model="user.address_street"/>
        <div class="invalid-tooltip d-block" v-if="errors.has('address_street')">{{ errors.first('address_street') }}</div>
      </div>
      <div class="col-12 col-md-6 col-lg-4 p-1">
        <label class="control-label visible-ie8 visible-ie9" for="address_town">City/Town</label>
        <input
                :class="{'form-control': true, 'is-invalid': errors.has('address_town')}"
                v-validate="'required'"
                data-vv-delay="500"
                data-vv-as="City/Town"
                data-vv-name="address_town"
                type="text"
                placeholder="City/Town"
                name="address_town"
                id="address_town"
                v-model="user.address_town"/>
        <div class="invalid-tooltip d-block" v-if="errors.has('address_town')">{{ errors.first('address_town') }}</div>
      </div>
      <div class="col-12 col-md-6 col-lg-4 p-1">
        <label class="control-label visible-ie8 visible-ie9" for="address_state">State</label>
        <select :class="{'form-control': true, 'is-invalid': errors.has('address_state')}"
                v-validate="'required'"
                data-vv-delay="500"
                data-vv-as="State"
                data-vv-name="address_state"
                name="address_state"
                id="address_state"
                v-model="user.address_state">
          <option label="ACT" :value="1">ACT</option>
          <option label="NSW" :value="2" selected="selected">NSW</option>
          <option label="NT" :value="3">NT</option>
          <option label="QLD" :value="4">QLD</option>
          <option label="SA" :value="5">SA</option>
          <option label="TAS" :value="6">TAS</option>
          <option label="VIC" :value="7">VIC</option>
          <option label="WA" :value="8">WA</option>
        </select>
        <div class="invalid-tooltip d-block" v-if="errors.has('address_state')">{{ errors.first('address_state') }}</div>
      </div>
      <div class="col-12 col-md-6 col-lg-4 p-1">
        <label class="control-label visible-ie8 visible-ie9" for="address_postcode">Postcode</label>
        <input :class="{'form-control': true, 'is-invalid': errors.has('address_postcode')}"
               v-validate="'required|numeric'"
               data-vv-delay="500"
               data-vv-as="Postcode"
               data-vv-name="address_postcode"
               type="text"
               placeholder="Postcode"
               name="address_postcode"
               id="address_postcode"
               v-model="user.address_postcode"/>
        <div class="invalid-tooltip d-block" v-if="errors.has('address_postcode')">{{ errors.first('address_postcode') }}</div>
      </div>
      <div class="col-12 col-md-6 col-lg-4 p-1">
        <label class="control-label visible-ie8 visible-ie9" for="phone_mobile">Mobile Phone</label>
        <input
                :class="{'form-control': true, 'is-invalid': errors.has('phone_mobile')}"
                v-validate="'required|numeric'"
                data-vv-delay="500"
                data-vv-as="Mobile Phone"
                data-vv-name="phone_mobile"
                type="text"
                placeholder="Mobile Phone"
                name="phone_mobile"
                id="phone_mobile"
                v-model="user.phone_mobile"/>
        <div class="invalid-tooltip d-block" v-if="errors.has('phone_mobile')">{{ errors.first('phone_mobile') }}</div>
      </div>
      <div class="col-12 col-md-6 col-lg-4 p-1">
        <label class="control-label visible-ie8 visible-ie9" for="dob">Date Of Birth</label>
        <flat-pickr
                v-validate="'required'"
                data-vv-delay="500"
                data-vv-as="Date Of Birth"
                data-vv-name="dob"
                placeholder="Date Of Birth"
                name="dob"
                id="dob"
                class="form-control"
                :config="{dateFormat: 'd-m-Y'}"
                v-model="user.dob">
        </flat-pickr>
        <div class="invalid-tooltip d-block" v-if="errors.has('dob')">{{ errors.first('dob') }}</div>
      </div>
      <div class="col-12 col-md-6 col-lg-4 p-1">
        <label class="control-label visible-ie8 visible-ie9" for="gender">Gender</label>
        <select :class="{'form-control': true, 'is-invalid': errors.has('gender')}"
                v-validate="'required'"
                data-vv-delay="500"
                data-vv-as="Gender"
                data-vv-name="gender"
                name="gender"
                id="gender"
                v-model="user.gender">
          <option :value="1">Male</option>
          <option :value="2">Female</option>
          <option :value="3">Other</option>
        </select>
        <div class="invalid-tooltip d-block" v-if="errors.has('gender')">{{ errors.first('gender') }}</div>
      </div>
      <div class="col-12 p-1">
        <loading-button :loading="loading" block @submit="createUser">Create RTO Trainer</loading-button>
      </div>
    </div>
  </div>
</template>

<script>
import CheckEmail from '../../mixins/CheckEmail';
import debounce from 'lodash-es/debounce';

export default {
  name: 'CreateEmployer',
  mixins: [CheckEmail],
  data () {
    return {
      user: {
        name_company: '',
        name_first: '',
        name_last: '',
        email: '',
        address_street: '',
        address_town: '',
        address_state: '',
        address_postcode: '',
        phone_modile: '',
        dob: '',
        gender: '',
        role_id: 14
      },
      loading: false
    };
  },
  watch: {
    'user.email': debounce(function (val) {
      this.checkEmail(val);
    }, 2000)
  },
  methods: {
    createUser () {
      this.$validator.validate().then(result => {
        if (result) {

          this.loading = true;
          this.axios.post('/users/', this.user).then(() => {
            this.$store.commit('setRtoTrainers', []);
            this.$store.dispatch('LOAD_RTO_TRAINERS', this);
            this.$emit('close');
            this.$swal('success', 'RTO Trainer Created', 'success');
          }).catch(err => {
            this.loading = false;
            this.$swal('error', err.response.data.message, 'error');
          });
        }
      });

    }
  },
  mounted () {}
};
</script>
